module.exports = __webpack_public_path__ + "img/full-brigadeiro.4e9aa5af.svg";